import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaNotasLayer from "../components/ListaNotasLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaNotasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("nota.breadcrumb.lista")} />
      <ListaNotasLayer />
    </MasterLayout>
  );
};

export default ListaNotasPage;
